import React from 'react';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import useUser from './hooks/useUser';
import Page from './Page';
import AdminSideNav from './AdminSideNav';

export default function AdminPage(props) {
  const { children } = props;
  const { user } = useUser();
  const history = useHistory();

  if (user && !user.admin) {
    toast.error('Not authorized');
    history.replace('/');
    return null;
  }

  return user != null && (
    <Page admin={true}>
      <div className="d-flex">
        <AdminSideNav style={{ top: 51, width: 250, minWidth: 250 }} />
        <div className="flex-fill d-flex" style={{ marginLeft: 250, marginTop: 51 }}>
          {[children].flat().map(_ => ({ ..._, props: { ..._.props, user } }))}
        </div>
      </div>
    </Page>
  );
}
